import { css } from '@emotion/react';

import { Colors, Link, Typography } from '@zapier/design-system';
import { urls, useSize } from '@zapier/identity-utils';

import {
  AuthLayout,
  CompaniesIntroPromo,
} from '@zapier/auth-pages/src/components/global';

const textStyle = css`
  ${Typography.paragraph1}
  color: ${Colors.neutral800};
  text-align: center;
`;

const rootStyle = css`
  display: grid;
  gap: 20px;
  padding: 40px 0;
`;

export function LockedAccountPage() {
  const size = useSize();

  return (
    <AuthLayout
      promo={<CompaniesIntroPromo />}
      showPromo={size !== 'small'}
      title={'Your account is locked'}
      titlePosition={'right'}
    >
      <section css={rootStyle}>
        <p css={[textStyle]}>
          To unlock your account, please{' '}
          <Link href={urls.FORGOT_PASSWORD_URL}>reset your password</Link>.
        </p>
      </section>
    </AuthLayout>
  );
}
